// Vendor
import * as docsify from 'docsify';
import * as docsifycc from 'docsify-copy-code';
import * as docsifydlt from "docsify-darklight-theme/dist/index.min.js"

// Make available globally
window.docsify = docsify;